import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieConsent from '../../components/feature/CookieConsent';

interface CourseOption {
  id: number;
  title: string;
  price: string;
  courses: string[];
  category: string;
}

const courseOptions: CourseOption[] = [
  {
    id: 1,
    title: 'Reserva de cursos por',
    price: '25€',
    category: 'option1',
    courses: [
      'Aparatos elevadores. (5 máquinas por 150€)',
      'Movimiento de tierras. (5 máquinas por 150€)',
      'Maquinaria de Almacén. (4 máquinas por 150€)',
      'Maquinaria Forestal y Jardinería.',
      'Tractor agrícola.'
    ]
  },
  {
    id: 2,
    title: 'Reserva de 2 cursos por',
    price: '50€',
    category: 'option2',
    courses: [
      'Aparatos elevadores + Movimiento de tierras.',
      'Aparatos elevadores + Maquinaria de Almacén.',
      'Movimiento de tierras + Maquinaria de Almacén.',
      'Mozo de almacén + Maquinaria de Almacén.',
      'Aparatos elevadores + Carga y Estibas en el transporte.',
      'Movimiento de tierras + Carga y Estibas en el transporte.'
    ]
  },
  {
    id: 3,
    title: 'Reserva de cursos por',
    price: '50€',
    category: 'option3',
    courses: [
      'Mozo de almacén'
    ]
  },
  {
    id: 4,
    title: 'Reserva de cursos por',
    price: '150€',
    category: 'option3',
    courses: [
      'Trabajos en altura - Técnicas de acceso y posicionamiento mediante cuerdas'
    ]
  },
  {
    id: 5,
    title: 'Reserva de cursos por',
    price: '25€',
    category: 'option4',
    courses: [
      'Carga y Estibas en el transporte.',
      'Carretillas elevadoras automotoras.',
      'Carretillas retráctil automotoras.',
      'Montaje, Desmontaje y Uso de Andamios Homologados.',
      'Puente grúa.'
    ]
  },
  {
    id: 6,
    title: 'Reserva de 3 y 4 cursos',
    price: '',
    category: 'option5',
    courses: [
      'Aparatos elevadores + Movimiento de tierras + Maquinaria de Almacén.',
      'Aparatos elevadores + Movimiento de tierras + Maquinaria de Almacén + Maquinaria Forestal y Jardinería'
    ]
  }
];

const prefillUrls: Record<string, string> = {
  '13': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=829559', // Ap. Elev + Mov. Tierr. + Maq. Almacén
  '16': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=376578', // Mozo Almacén + Maq. Almacén
  '15': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=372366', // Mov. Tierras + Maq. Almacén
  '14': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=617764', // Ap. Elevadores + Maq. Almacén
  '18': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=915248', // Ap. Elevadores + Mov. Tierras
  '322371': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=322371', // Movimiento de Tierras
  '781892': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=781892', // Maquinaria de Almacén
  '294542': 'https://forms.zohopublic.com/institutocefa1/form/Maquinariaprivado/formperma/DfTkyhcmCyqCtfKU-Cu0pazblVALF5sJQENWkmDls8s?zf_pf_id=294542'  // Aparatos elevadores
};

const Home = () => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [selectedCourse, setSelectedCourse] = useState<string>('0');
  const [showAlert, setShowAlert] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleSelectOption = (category: string) => {
    setSelectedOption(category);
    setShowAlert(false);
  };

  const handleSelectCourse = () => {
    if (!selectedCourse || selectedCourse === '0') {
      setShowAlert(true);
      return;
    }
    setShowForm(true);
    setShowAlert(false);
  };

  const handleBack = () => {
    setSelectedOption(null);
    setSelectedCourse('0');
    setShowForm(false);
    setShowAlert(false);
  };

  const getCourseSelectOptions = () => {
    switch (selectedOption) {
      case 'option1':
        return [
          { value: '0', label: 'Elige tu curso' },
          { value: '294542', label: 'Aparatos Elevadores (5 máquinas por 150€)' },
          { value: '322371', label: 'Movimiento de Tierras (5 máquinas por 150€)' },
          { value: '781892', label: 'Maquinaria de Almacén (4 máquinas por 150€)' },
          { value: '5', label: 'Maquinaria Forestal y Jardinería' },
          { value: '4', label: 'Tractor Agrícola' }
        ];
      case 'option2':
        return [
          { value: '915248', label: 'Ap. Elevadores + Mov. Tierras' },
          { value: '14', label: 'Ap. Elevadores + Maq. Almacén' },
          { value: '15', label: 'Mov. Tierras + Maq. Almacén' },
          { value: '16', label: 'Mozo de almacén + Maq. Almacén' },
          { value: '17', label: 'Ap. Elevadores + Carga y Estibas en el Transporte' },
          { value: '18', label: 'Mov. Tierras + Carga y Estibas en el Transporte' }
        ];
      case 'option3':
        return [
          { value: '12', label: 'Mozo de almacén' },
          { value: '7', label: 'Trabajos en altura - Técnicas de acceso y posicionamiento mediante cuerdas' }
        ];
      case 'option4':
        return [
          { value: '3', label: 'Carga y Estibas en el Transporte' },
          { value: '11', label: 'Carretillas elevadoras automotoras' },
          { value: '9', label: 'Carretillas retráctil automotoras' },
          { value: '6', label: 'Montaje, Desmontaje y Uso de Andamios Homologados' },
          { value: '10', label: 'Puente grúa' }
        ];
      case 'option5':
        return [
          { value: '13', label: 'Ap. Elev + Mov. Tierr. + Maq. Almacén' },
          { value: '20', label: 'Ap. Elev + Mov. Tierr. + Maq. Almacén + Maq. Forestal y Jardinería' }
        ];
      default:
        return [];
    }
  };

  const getIframeSrc = () => {
    return prefillUrls[selectedCourse] || '';
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      <section className="bg-orange-500 pt-32 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-black uppercase">
            Ficha de Registro para cursos teórico / prácticos
          </h1>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <form onSubmit={(e) => e.preventDefault()} data-readdy-form>
            {!selectedOption && (
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                {courseOptions.map((option) => (
                  <div key={option.id} className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {option.title} {option.price && <span className="text-3xl text-orange-500">{option.price}</span>}
                    </h3>
                    <ul className="space-y-2 mb-6">
                      {option.courses.map((course, idx) => (
                        <li key={idx} className="text-gray-700 text-sm flex items-start">
                          <span className="mr-2">•</span>
                          <span>{course}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="text-center">
                      <button
                        type="button"
                        onClick={() => handleSelectOption(option.category)}
                        className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                      >
                        ME INTERESA <i className="fas fa-hand-pointer ml-2"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {selectedOption && !showForm && (
              <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Selecciona tu curso</h3>
                <select
                  value={selectedCourse}
                  onChange={(e) => setSelectedCourse(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg mb-6 text-gray-700 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  {getCourseSelectOptions().map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                {showAlert && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6">
                    Debe seleccionar un curso
                  </div>
                )}

                <div className="flex gap-4 justify-center">
                  <button
                    type="button"
                    onClick={handleSelectCourse}
                    className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    SELECCIONAR CURSO <i className="fas fa-hand-pointer ml-2"></i>
                  </button>
                  <button
                    type="button"
                    onClick={handleBack}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="fas fa-arrow-circle-left mr-2"></i> VOLVER
                  </button>
                </div>
              </div>
            )}

            {showForm && (
              <div className="bg-white rounded-lg shadow-lg p-8">
                <div className="mb-6">
                  <p className="text-gray-700">
                    Por favor, completa todos los campos, <span className="font-bold text-red-600">tal como aparecen en tu documento de identidad</span>, para realizar la matriculación del curso seleccionado.
                  </p>
                </div>

                <div className="mb-6">
                  <iframe
                    aria-label="Maquinaria privado"
                    frameBorder="0"
                    style={{ height: '800px', width: '99%', border: 'none' }}
                    src={getIframeSrc()}
                  ></iframe>
                </div>

                <div className="flex gap-4 justify-center">
                  <button
                    type="button"
                    onClick={handleBack}
                    className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="fas fa-arrow-circle-left mr-2"></i> VOLVER
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
};

export default Home;